import { useNavigate } from 'react-router-dom';
import { Settings, Calendar, Building2, UserPlus, Star, DollarSign, Plug, ChevronRight, Users } from 'lucide-react';
import { Card } from '@/components/Card';

const ADMIN_SECTIONS = [
  {
    to: '/admin/pto-policies',
    icon: Calendar,
    title: 'PTO Policies',
    description: 'Configure PTO accrual rates, flat allocations, carryover limits, and waiting periods.',
  },
  {
    to: '/admin/departments',
    icon: Building2,
    title: 'Departments',
    description: 'Manage departments, hierarchy, cost centers, and reporting structure.',
  },
  {
    to: '/admin/onboarding-templates',
    icon: UserPlus,
    title: 'Onboarding Templates',
    description: 'Create and manage step-based onboarding and offboarding checklists.',
  },
  {
    to: '/admin/review-cycles',
    icon: Star,
    title: 'Review Cycles',
    description: 'Configure performance review schedules, reviewer types, and question banks.',
  },
  {
    to: '/admin/salary-bands',
    icon: DollarSign,
    title: 'Salary Bands',
    description: 'Define salary ranges by level and job family, with visual band comparison.',
  },
  {
    to: '/admin/integrations',
    icon: Plug,
    title: 'Integrations',
    description: 'PSA, Books, and Hub integration settings, sync frequency, and connection status.',
  },
  {
    to: '/admin/access',
    icon: Users,
    title: 'Team & Access',
    description: 'Manage Hub team members, API keys, and review the audit log.',
  },
];

export function AdminPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
        <Settings className="w-5 h-5 text-amber-500" /> HR Admin
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {ADMIN_SECTIONS.map(section => (
          <Card key={section.to} onClick={() => navigate(section.to)} className="hover:border-amber-500/30 border border-transparent transition-colors">
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3">
                <section.icon className="w-5 h-5 text-amber-500 mt-0.5 shrink-0" />
                <div>
                  <h3 className="text-sm font-medium text-foreground">{section.title}</h3>
                  <p className="text-xs text-muted-foreground mt-1">{section.description}</p>
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0 mt-0.5" />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
